import { useParams } from "react-router-dom";

import { EmployeePageHeader, Employee } from "./components";

const EmployeeDetails = () => {
  const { id } = useParams();

  return (
    <div className="w-100 px-10 pt-10">
      <EmployeePageHeader id={id} />
      <div className="pt-10">
        <Employee id={id ? Number(id) : null} isProfile={false} />
      </div>
    </div>
  );
};

export default EmployeeDetails;
